import { createContext } from 'react';
import { AppInfo } from 'src/types/graphql-types';

export const AppInfoContext = createContext<AppInfo & { isLoaded: boolean }>({
  maintenanceMode: false,
  maintenanceMessage: '',
  isViewAsUser: false,
  isLoaded: false,
});
